import { AppProviders } from './core/providers';
import { RouteProvider } from './core/providers/RouteProvider';

function App() {
  return (
    <AppProviders>
      <RouteProvider />
    </AppProviders>
  );
}

export default App;
